<template>
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col-3 pr-1 mb-3">
                    <input v-model="account_no" placeholder="একাউন্ট নম্বর" autocomplete="on" class="form-control formInput" type="text">
                </div>
                <div class="col-3 pl-1 pr-1 mb-3">
                    <input v-model="phone" placeholder="মোবাইল নম্বর" class="form-control formInput" type="text">
                </div>
                <div class="col-3 pl-1 mb-3">
                    <button @click.prevent="getResults()" class="mr-2 btn btn-success my-2 my-sm-0 formInput" >Search</button>
                    <button @click.prevent="download()" class="btn btn-success my-2 my-sm-0 formInput" >Download</button>
                </div>
                <div class="col-3 text-right">
                    <a class="btn btn-info" href="/report"><i class="fa fa-angle-left" aria-hidden="true"></i> Back</a>
                </div>
            </div>
            <div class="content_inner" v-if="data">
                <div class="row">
                    <div class="col-3">একাউন্ট নম্বর</div>
                    <div class="col-9">: {{ data.account_no}} </div>
                </div>
                <div class="row">
                    <div class="col-3">গ্রাহকের নাম</div>
                    <div class="col-9">: {{ data.user_name }}</div>
                </div>
                <div class="row">
                    <div class="col-3">পিতা/স্বামীর নাম</div>
                    <div class="col-9">: {{ data.fathers_or_husband_name }}</div>
                </div>
                <div class="row">
                    <div class="col-3">রাস্তা / এলাকার নাম</div>
                    <div class="col-9">: {{ data.road_name }}<span v-if="data.moholla_name"> / {{ data.moholla_name }} </span></div>
                </div>
                <div class="row">
                    <div class="col-3">গ্রাহকের ঠিকানা</div>
                    <div class="col-9">: {{ data.address }}</div>
                </div>
                <div class="row">
                    <div class="col-3">ওয়ার্ড নং</div>
                    <div class="col-9">: {{ data.ward_no }}</div>
                </div>
                <div class="row">
                    <div class="col-3">গ্রাহকের ধরন</div>
                    <div class="col-9">: {{ data.line_type }}</div>
                </div>
                <div class="row">
                    <div class="col-3">ডায়ার ব্যাস</div>
                    <div class="col-9">: {{ data.diameter }}</div>
                </div>
                <div class="row">
                    <div class="col-3">গ্রাহক সংযোগের তারিখ</div>
                    <div class="col-9">: {{ data.approve_date }}</div>
                </div>
                <div class="row">
                    <div class="col-3">ব্যাংকের আইডি এবং নাম</div>
                    <div class="col-9">: </div>
                </div>
                <div class="row">
                    <div class="col-3">বিলের মাস</div>
                    <div class="col-9">: {{ data.ward_no }}</div>
                </div>
                <div class="row">
                    <div class="col-3">বিলের বছর</div>
                    <div class="col-9">: {{ data.ward_no }}</div>
                </div>
                <div class="row">
                    <div class="col-3">মাসিক বিল</div>
                    <div class="col-9">: {{ data.ward_no }}</div>
                </div>
                <div class="row">
                    <div class="col-3">বকেয়া</div>
                    <div class="col-9">: {{ data.ward_no }}</div>
                </div>
                <div class="row">
                    <div class="col-3">সারচার্জ</div>
                    <div class="col-9">: {{ data.ward_no }}</div>
                </div>
                <div class="row">
                    <div class="col-3">মোট বিল</div>
                    <div class="col-9">: {{ data.ward_no }}</div>
                </div>
                <div class="row">
                    <div class="col-3">বর্তমান অবস্থা</div>
                    <div class="col-9">: {{ data.ward_no }}</div>
                </div>
                <div class="row">
                    <div class="col-3">বিল পরিশোধের তারিখ</div>
                    <div class="col-9">: {{ data.ward_no }}</div>
                </div>
            </div>
            <div v-else class="text-capitalize font-weight-bold">Data is not exists !!!</div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import Vue from 'vue'
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
import axios from "axios";
export default {
    data(){
        return {
            account_no:'',
            phone:'',
            data:{},
            invoice_type:'water-billing'
        }
    },
    methods:{
        async getResults(){
            var data = {
                phone:this.phone,
                account_no:this.account_no,
                invoice_type:this.invoice_type
            }
            axios.post('api/water-applicant-details',data).then(response=>{
                this.data = response.data
                console.log(count(this.data));
            })
        },
        getFormatedData(val) {
            return val.toFixed(2);
        },
        download(){
            this.$validator.validateAll().then( result =>{
                if(result){
                    let getUserInfo = JSON.parse(localStorage.getItem('user'))
                    let loggedUser = getUserInfo.name
                    var start = ''
                    var end = ''
                    if(this.date){
                        start = this.date.start
                        end = this.date.end
                    }
                    var download = 'download'

                    window.open(`${axios.defaults.baseURL}/api/water-bill-report?download=${download}&phone=${this.phone}&account_no=${this.account_no}&start=${start}&end=${end}&status=${this.status}&ward=${this.ward}&bank=${this.bank}&invoice_type=${this.invoice_type}&loggeduser=${loggedUser}`)
                }
            })
        },
    },
    mounted(){
        //this.getResults()
    },
    computed:{
    },
    components: {
    }
}
</script>
<style scoped>
    .formInput{ height: 41px;}
    .date-time-picker label,.card{font-family: 'Hind Siliguri Light' !important; font-size: 16px;}
    .form-control{ font-size: 16px;}
    .btn-info{ color: #fff; text-transform: capitalize; height: 42px; line-height: 42px; padding: 0rem 0.75rem;}
    .content_inner{ border: 1px solid #c8ced3; padding: 10px;}
</style>
